<p>You'll receive an email when it's ready.</p>
<p>
  We'll keep all exports for 14 days on your <a [routerLink]="['exports']" (click)="closeModal.emit()">Export Page.</a>
</p>
